import { useState, useEffect } from 'react';

const useWindowSize = () => {
  const windowSize = {
    width: window.innerWidth,
    height: window.innerHeight,
  }
  return windowSize;
};

export default useWindowSize;